import { ArrowPathRoundedSquareIcon } from "@heroicons/react/24/outline";
import { formatDateTime } from "src/helpers/serverMonitorHelper";

// Crashes with the same cause more than once in the last 7 days - a recurring bug rather than a one-off.
const RepeatedCrashes = ({ groups = [], onView }) => {
  if (!groups.length) return null;
  return (
    <div className="mt-8 rounded-md border border-red-200 bg-red-50 px-4 py-3">
      <div className="flex items-center gap-2 text-sm font-semibold text-red-800">
        <ArrowPathRoundedSquareIcon className="h-5 w-5" /> Repeated crashes in the last 7 days
      </div>
      <ul className="mt-2 space-y-2">
        {groups.map((group) => (
          <li
            key={group.key}
            className="flex flex-wrap items-center justify-between gap-2 text-sm text-red-900">
            <span className="min-w-0 break-words">
              <b>{group.count}×</b> {group.label} <span className="text-xs text-red-700">(last {formatDateTime(group.last_at, "MMM D, h:mm A")})</span>
            </span>
            <button
              type="button"
              className="text-xs font-medium text-red-800 underline hover:text-red-900"
              onClick={() => onView({ _id: group.latest_incident_id })}>
              View latest
            </button>
          </li>
        ))}
      </ul>
      <p className="mt-2 text-xs text-red-700">The same error keeps coming back - it needs a code fix, a restart will not solve it.</p>
    </div>
  );
};

export default RepeatedCrashes;
